import type { FC, SVGProps } from "react";

const IconCopy: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M13.333 5.33398H6.66634C5.92996 5.33398 5.33301 5.93094 5.33301 6.66732V13.334C5.33301 14.0704 5.92996 14.6673 6.66634 14.6673H13.333C14.0694 14.6673 14.6663 14.0704 14.6663 13.334V6.66732C14.6663 5.93094 14.0694 5.33398 13.333 5.33398Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2.66634 10.6673C1.93301 10.6673 1.33301 10.0673 1.33301 9.33398V2.66732C1.33301 1.93398 1.93301 1.33398 2.66634 1.33398H9.33301C10.0663 1.33398 10.6663 1.93398 10.6663 2.66732" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconCopy
